export * from './ProductCharacteristics';
